<template lang="html">
  <div class="grid-x align-middle fromtoselect2">
    <div class="cell auto">
      <select2
          :options="options.from"
          ref="from"
          :value="modelValue[0]"
          data-theme="dk"
          data-placeholder="C"
          data-allow-clear="true"
          data-minimum-results-for-search="Infinity"
          @change="onChange"
          >
      </select2>
    </div>
    <div class="hyphen cell shrink">&nbsp;-&nbsp;</div>
    <div class="cell auto">
      <select2
          :options="options.to"
          ref="to"
          :value="modelValue[1]"
          data-theme="dk"
          data-placeholder="По"
          data-allow-clear="true"
          data-minimum-results-for-search="Infinity"
          @change="onChange"
          >
      </select2>
    </div>
  </div>
</template>

<script>
import select2 from './select2.vue';

export default {
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  props: {
    modelValue: {
      default: function() {
        return []
      },
    },
    options: {
      default: '',
    },
  },
  methods: {
    onChange(evt) {
      var model = [
        this.$refs.from.$el.value,
        this.$refs.to.$el.value
      ]
      this.$emit('input', model);
    }
  },
  watch: {
    modelValue(newValue, oldValue) {
      $(this.$refs.from.$el).val( this.modelValue[0] ).trigger('change.select2');
      $(this.$refs.to.$el).val( this.modelValue[1] ).trigger('change.select2');
    }
  },
  components: {
    "select2": select2
  },
}
</script>

<style lang="scss">
.fromtoselect2{
  .select2-selection__clear{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fromtoselect2.vue